import { PageHeaderData } from '@/atomic-components';
import { BundleApi } from '@/types';
import ng from 'angular';

export class TemplateBundleExtensionsController {
    public static $inject: string[] = ['$translate'];

    public bundle: BundleApi.Bundle;
    public bundleUpgradeInfo: BundleApi.BundleUpgradeInfo;
    public pageHeaderData: PageHeaderData;

    constructor(
        private $translate: ng.translate.ITranslateService,
    ) {}

    public $onInit() {
        this.pageHeaderData = {
            backwardLink: 'bundle.id.dashboard',
            backwardText: this.$translate.instant('TR_090119-a32485_TR'),
            panelHeaderRoute: '',
            panelHeaderRouteParams: { bundleId: this.bundle.id },
            panelIcon: 'box-alt',
            panelTitle: this.bundle.name + ' - '
                + this.$translate.instant('TR_010726-4341fe_TR'),
        };
    }

}

export class TemplateBundleExtensionsComponent implements ng.IComponentOptions {
    public bindings = {
        bundle: '<',
        bundleUpgradeInfo: '<',
    };
    public controller = TemplateBundleExtensionsController;
    public template = require('./bundle-extensions-template.html');
}
